export default __webpack_public_path__ + "static/media/grafismo-top.cf5f8fad.png";